module.exports = __webpack_public_path__ + "img/bank2.af25d5af.png";